import React, { Component } from 'react';


export class EndOfTurnEventComponent extends Component {
    componentDidMount() {
        this.props.app.gameController.stopEngineBackgroundSound();
    }

    render() {
        return <></>;
    }

}
